export default __webpack_public_path__ + "static/media/banner-c.2b85d3c5.jpg";